import ConfirmDialog from './ConfirmDialog'

export default function DangerDialog(props) {
    return <ConfirmDialog {...props} tone="danger" />
}
